export const notificationDeliveryTargets = ['team', 'user', 'subject'] as const

type NotificationTemplateTarget = typeof notificationDeliveryTargets[number]
export default NotificationTemplateTarget
